var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"page-not-found-text"},[_vm._v("Page Not Found")])
}
var staticRenderFns = []

export { render, staticRenderFns }